// Ce fichier est généré automatiquement par scripts/generate-router-plugin.js
// Ne pas modifier manuellement - vos changements seront écrasés
// Pour régénérer : pnpm run generate:router-plugin

import type { RouteRecordRaw } from "vue-router"

import PageBuildingWrapper from "@core/pages/building/PageBuildingWrapper.vue"
import {
    buildingShellMeta,
    coreBuildingShellChildrenHead,
    coreBuildingShellChildrenTail,
} from "./building.routes"

import { buildingShellChildren as dataBuildingShellChildren } from "@modules/data/building.routes"

import { buildingShellChildren as energyManagerBuildingShellChildren } from "@modules/energy-manager/building.routes"
import { buildingShellChildren as usageProfileBuildingShellChildren } from "@modules/usage-profile/building.routes"
import { buildingShellChildren as irveBuildingShellChildren } from "@modules/irve/building.routes"
import { buildingShellChildren as courtageBuildingShellChildren } from "@modules/courtage/building.routes"
import { buildingShellChildren as alarmesV2BuildingShellChildren } from "@modules/alarmes-v2/building.routes"
import { buildingShellChildren as pvBuildingShellChildren } from "@modules/pv/building.routes"

/**
 * Route coquille fiche bâtiment : fusion des enfants core + modules (`building.routes.ts`).
 * Fichier généré — modifier les segments dans `building.routes.ts` ou les modules.
 */
export const buildingShellRoute: RouteRecordRaw = {
    path: "building/:_id_building",
    component: PageBuildingWrapper,
    meta: buildingShellMeta,
    children: [
        ...coreBuildingShellChildrenHead,
        ...dataBuildingShellChildren,
        ...coreBuildingShellChildrenTail,
        ...energyManagerBuildingShellChildren,
        ...usageProfileBuildingShellChildren,
        ...irveBuildingShellChildren,
        ...courtageBuildingShellChildren,
        ...alarmesV2BuildingShellChildren,
        ...pvBuildingShellChildren,
    ],
}
